import React, {Component, Fragment} from 'react'
import {Form, Input, Row, Col, Select, DatePicker, Button, Pagination, message,} from 'antd';
import moment from 'moment'
import 'moment/locale/zh-cn';
import {reqTrackList, reqCustomsPorts, reqBusinessAll} from '../../api'
import LinkButton from '../../components/link-button'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import {
    ORDER_STATUS, LOGISTICS_STATUS, DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_AIR, PLAN_DELIVERY_TYPE
} from '../../utills/constants'
import {convertToOptions} from "../../components/options";
import {getIcons} from '../../utills/common'

const AuthButton = authorizeBase(Button);
const AuthLinkButton = authorizeBase(LinkButton);
const {Option} = Select;

moment.locale('zh-cn');

class TrackList extends Component {

    state = {
        pageNum: 1,
        pageSize: 10,
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        loading: false, // 是否正在加载中
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {},
        arrow: 'up-arrow',
        declareModes: {},
    };

    getProducts = async (pageNum = 1, pageSize = 10, sortData) => {
        this.setState({pageNum, pageSize});
        const {getFieldsValue} = this.props.form;
        const {deliveryFromDt, deliveryToDt} = this.state;
        const values = getFieldsValue();
        values.deliveryFromDt = deliveryFromDt;
        values.deliveryToDt = deliveryToDt;
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        if (sortData) {
            values.sort = sortData.sort;
            values.order = sortData.order
        }
        let result = await reqTrackList(values);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };

    componentWillMount() {
        this.getBusinessAll();
    }

    componentDidMount() {
        this.getProducts();
        this.getCustomsPorts();
    }

    getCustomsPorts = async () => {
        let result = await reqCustomsPorts();
        if (result.code === 200) {
            this.setState({
                customsPorts: [{
                    customsPortCode: '',
                    customsPortName: "全部",
                }, ...result.data],
            })
        } else {
            message.error(result.message)
        }

    };
    //货物类型
    getBusinessAll = async () => {
        let result = await reqBusinessAll();
        if (result.code === 200) {
            const data = {};
            result.data.forEach((o) => {
                data[o.businessCode] = o.businessName;
            });
            this.setState({declareModes: data})
        }
    };
    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1;
            values.pageSize = this.state.pageSize;
            this.setState({pageNum: 1});
            const {deliveryFromDt, deliveryToDt, sortData} = this.state;
            values.deliveryFromDt = deliveryFromDt;
            values.deliveryToDt = deliveryToDt;
            if (sortData) {
                values.sort = sortData.sort;
                values.order = sortData.order
            }
            if (!err) {
                this.reqTrackList(values);
            }
        });
    };

    reqTrackList = async (po) => {
        const result = await reqTrackList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        }
    };

    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString);
        this.setState({
            deliveryFromDt: dateString
        })
    };
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString);
        this.setState({
            deliveryToDt: dateString
        })
    };
    moreClick = () => {
        const {arrow} = this.state;
        this.setState({
            arrow: arrow === 'down-arrow' ? 'up-arrow' : 'down-arrow'
        })
    };

    render() {
        // 取出状态数据
        const {arrow, declareModes, orderList, pageNum, pageSize, total} = this.state;
        const form = this.props.form;
        const {getFieldDecorator} = form;
        const formItemLayout = {
            labelCol: {
                lg: {span: 8},
                md: {span: 8},
            },
            wrapperCol: {
                lg: {span: 14},
                md: {span: 12},
            },
        };
        const divs = (orderList || []).map((o, i) => {
            let declareMode;
            if (o.declareMode) {
                let len = o.declareMode.indexOf('+');
                if (len > 0 && declareModes[o.declareMode]) {
                    let textArray = declareModes[o.declareMode].split('/');
                    declareMode = <Fragment>{textArray[0]}<br/>{textArray[1]}</Fragment>
                } else {
                    declareMode = declareModes[o.declareMode]
                }
            }
            return <Fragment>
                <div className="list-item">
                    <div className="head">
                        <div className="info">
                            <div className="info-item main-color">{DELIVERY_TYPE[o.deliveryType]}</div>
                            <div className="info-item">
                                <span className="grey-color">订单编号：</span>
                                <a onClick={() => this.props.history.push('/orderInfo', o)}>{o.orderNo}</a>
                            </div>
                            {o.deliveryTime ?
                                <div className="info-item">
                                    <span className="grey-color">提货时间：</span>{o.deliveryTime}
                                </div> :
                                <div className="info-item ">
                                    <span className="grey-color">预计提货时间：</span>{o.deliveryEstimateDt}
                                </div>}
                        </div>
                        <div className="opt">
                            {(o.orderStatus === 'new' || o.orderStatus === 'failed' || o.orderStatus === 'booked') ?
                                <Fragment>
                                    <AuthLinkButton authority="order:edit"
                                                    onClick={() => this.props.history.push('/trackEdit', {orderId: o.id})}>编辑</AuthLinkButton>
                                    <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: o.id})}>物流查询</a>
                                </Fragment> :
                                <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: o.id})}>物流查询</a>
                            }
                        </div>
                    </div>
                    <div className="content">
                        <div className="col col1">
                            <div>
                                <div className="route">
                                    <div className="main-color">{o.originCity}</div>
                                    <div className="line">
                                        <div className="line-text">
                                            {DELIVERY_TYPE_MIX.hasOwnProperty(o.deliveryType) ?
                                                <Fragment>
                                                    <span
                                                        className="grey-color">{PLAN_DELIVERY_TYPE.hasOwnProperty(o.deliveryType) || o.deliveryType === 'D' ? '目的站' : '转关地'}：</span>{o.destinationStartCity}
                                                </Fragment> :
                                                <Fragment>
                                                    <span className="grey-color">清关地：</span>{o.customsClearanceCity}
                                                </Fragment>}
                                        </div>
                                    </div>
                                    <div className="main-color">{o.destinationCity}</div>
                                </div>
                                <div className="info">
                                    {DELIVERY_TYPE_AIR.hasOwnProperty(o.deliveryType) ?
                                        <Fragment>
                                            <span className="info-item">
                                                <span className="grey-color">目的机场：</span>{o.destinationStartCity}
                                            </span>
                                        </Fragment> :
                                        <Fragment>
                                             <span className="info-item">
                                                <span className="grey-color">集装箱号：</span>{o.boxNo}
                                            </span>
                                            <span className="info-item">
                                                <span className="grey-color">还箱地：</span>{o.boxReturnStation}
                                            </span>
                                        </Fragment>}
                                </div>
                            </div>
                        </div>
                        <div className="col col2">{o.customsPortName}<br/>{declareMode}</div>
                        <div className="col col3">{getIcons(o, o.deliveryType)}</div>
                        <div className="col col4">{ORDER_STATUS[o.orderStatus]}</div>
                        <div className="col col5">{LOGISTICS_STATUS[o.logisticsStatus]}</div>
                    </div>
                </div>
            </Fragment>
        });
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <div className='head-title'>委托单信息列表
                        <span className="arrow"
                              onClick={this.moreClick}>{this.state.arrow === 'down-arrow' ? '收起' : '更多'}
                            <span className={arrow}></span></span></div>
                    <br/>
                    <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={6}>
                                <Form.Item label="订单编号">
                                    {getFieldDecorator('orderNo', {})(<Input/>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="集装箱号">
                                    {getFieldDecorator('boxNo', {})(<Input/>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="提货时间" className='time-input-to'>
                                    {getFieldDecorator('deliveryFromDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange} style={{width: "100%", minWidth: 10}}
                                    />)}

                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={"至"} className='time-input-to'>
                                    {getFieldDecorator('deliveryToDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange2} style={{width: "100%", minWidth: 10}}
                                    />)}
                                </Form.Item>
                            </Col>
                            {arrow === 'down-arrow' ?
                                <Fragment>
                                    <Col span={6}>
                                        <Form.Item label="起运地">
                                            {getFieldDecorator('departure', {})(<Input/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="转关地/清关地/目的机场">
                                            {getFieldDecorator('transitPoint', {})(<Input/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item label="目的地">
                                            {getFieldDecorator('destination', {})(<Input/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item label="还箱地">
                                            {getFieldDecorator('boxReturnStation', {})(<Input/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item label="订单状态">
                                            {getFieldDecorator('orderStatus', {
                                                initialValue: '',
                                            })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                                <Option value="">全部</Option>{convertToOptions(ORDER_STATUS)}
                                            </Select>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item label="物流状态">
                                            {getFieldDecorator('logisticsStatus', {
                                                initialValue: '',
                                            })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                                <Option value="">全部</Option>{convertToOptions(LOGISTICS_STATUS)}
                                            </Select>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item label="运输类型">
                                            {getFieldDecorator('deliveryType', {
                                                initialValue: '',
                                            })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                                <Option value="">全部</Option>{convertToOptions(DELIVERY_TYPE)}
                                            </Select>)}
                                        </Form.Item>
                                    </Col>
                                </Fragment> : null}
                            <Col span={6} style={{float: 'right'}}>
                                <Button className='margin-btn' style={{float: 'right',}} type='primary'
                                        htmlType='submit'>查询</Button>
                                <AuthButton className='margin-btn' style={{float: 'right',}}
                                            authority={"order_start:commit"} onClick={e => {
                                    this.props.history.push('/orderTicket')
                                }}>新增</AuthButton>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow list'>
                    <div className="list-title">
                        <div className="col1">线路</div>
                        <div className="col2">报关出境</div>
                        <div className="col3">文件</div>
                        <div className="col4">订单状态</div>
                        <div className="col5">物流状态</div>
                    </div>
                    {divs}
                    <Pagination size="small"
                                current={pageNum}
                                pageSize={pageSize}
                                total={total}
                                pageSizeOptions={['10', '20', '30', '50', '100']}
                                showSizeChanger={true}
                                showQuickJumper={true}
                                onChange={(page, pageSize) => this.getProducts(page, pageSize)}
                                onShowSizeChange={(current, pageSize) => this.getProducts(1, pageSize)}
                    />
                    <div style={{height: '40px'}}></div>
                </div>
            </div>
        )
    }
}

const TrackListFrom = authorizePage("order:search_delivery")(Form.create()(TrackList));
export default TrackListFrom